import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/portfolio.css';

export default function NavBar({ dark, onDarkChange, lang, onLangChange }) {
  const navigate = useNavigate();

  return (
    <header className="pf-nav">
      <div className="pf-nav-left">
        <button className="pf-nav-back" onClick={() => navigate('/')}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
          </svg>
          Back to Portfolio
        </button>
      </div>

      <div className="pf-nav-right">
        {onLangChange && (
          <div className="pf-lang-switch">
            {['en','ar'].map(l => (
              <button
                key={l}
                className={`pf-lang-btn${lang === l ? ' active' : ''}`}
                onClick={() => onLangChange(l)}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
        )}

        <button className="pf-theme-btn" onClick={() => onDarkChange && onDarkChange(!dark)} aria-label="Toggle theme">
          {dark ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <circle cx="12" cy="12" r="5"/>
              <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
              <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
            </svg>
          )}
        </button>

        <div className="pf-nav-sep" />
        <a href="https://linkedin.com/in/joudallahham" target="_blank" rel="noopener noreferrer" className="pf-nav-link">LinkedIn</a>
        <a href="https://github.com/joudall" target="_blank" rel="noopener noreferrer" className="pf-nav-link">GitHub</a>
        <a href="/JoudAlLahham_CV.pdf" download className="pf-cv-btn">Download CV</a>
      </div>
    </header>
  );
}
